import React, { useState } from 'react'
import { Navigate, NavLink, Outlet, useLocation, useMatch } from 'react-router-dom';
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormHelperText,
  Link,
  Stack,
  SvgIcon,
  TextField,
  Typography,
  Container,
  Alert
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Logo } from '../../components/logo';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAuth } from '../../hooks/useAuth';
import LoadingButton from '@mui/lab/LoadingButton'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { addDoc, collection, doc, getFirestore, setDoc, updateDoc } from 'firebase/firestore';

const TOP_NAV_HEIGHT = 64;

const LayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top center',
  backgroundImage: 'url("/assets/gradient.svg")',

  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  height: '100vh'
}))


export function Login() {

  const [loading, setLoading] = useState(false)
  const [loginError, setLoginError] = useState('')

  const initialValues = {
    email: '',
    password: '',
    submit: null
  }

  const validationSchema = Yup.object({
    email: Yup
      .string()
      .email('Deve ser um e-mail válido')
      .max(255)
      .required('O e-mail é obrigatório'),
    password: Yup
      .string()
      .max(255)
      .required('A senha é obrigatória'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, helpers) => {

      setLoading(true)
    
      const auth = getAuth()
      await signInWithEmailAndPassword(auth, values.email, values.password)
      .then(() => {
        setLoading(false)
      }).catch((error) => {
        
        switch (error.code) {
          case 'auth/invalid-email':
            setLoginError('O endereço de e-mail fornecido não é válido.')
            break;
          case 'auth/user-disabled':
            setLoginError('A conta de usuário foi desabilitada por um administrador.')
            break;
          case 'auth/user-not-found':
            setLoginError('Não há nenhum usuário com endereço de e-mail fornecido.')
            break;
          case 'auth/wrong-password':
            setLoginError(' A senha fornecida não corresponde ao endereço de e-mail fornecido.')
            break;
          default:
            setLoginError(' Não foi possivel encontrar sua conta.')
            break;
        }
      }).finally(() => {
        setLoading(false)
      })
  }})
  return (
    <LayoutRoot>
      <Box
        component="header"
        sx={{
          left: 0,
          position: 'fixed',
          right: 0,
          top: 40,
          zIndex: (theme) => theme.zIndex.appBar
        }}
      >
        <Container maxWidth="lg">
          <Stack
            spacing={2}
            sx={{ height: TOP_NAV_HEIGHT }}
          >
            <Stack
              alignItems="center"
              direction="row"
              display="inline-flex"
              spacing={1}
              sx={{ textDecoration: 'none' }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  height: 44,
                  width: 44,
                }}
              >
                <Logo />
              </Box>
            </Stack>
          </Stack>
        </Container>
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flex: '1 1 auto'
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            py: {
              xs: '60px',
              md: '120px'
            }
          }}
        >
      <Card elevation={16}>
        <CardHeader
          subheader={(
            <Typography
              color="text.secondary"
              variant="body2"
              mt={2}
            >
              Ainda não tem uma conta?
              &nbsp;
              <Link
                  href="/cadastro"
                  underline="hover"
                  variant="subtitle2" 
                >
                  Criar conta
                </Link>
            </Typography>
          )}
          sx={{ pb: 0 }}
          title="Login"
        />
        <CardContent>
          <form
            noValidate
            onSubmit={formik.handleSubmit}
          >
            <Stack spacing={3}>
              <TextField
                autoFocus
                error={!!(formik.touched.email && formik.errors.email)}
                fullWidth
                helperText={formik.touched.email && formik.errors.email}
                label="Email"
                name="email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="email"
                value={formik.values.email}
              />
              <TextField
                error={!!(formik.touched.password && formik.errors.password)}
                fullWidth
                helperText={formik.touched.password && formik.errors.password}
                label="Senha"
                name="password"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="password"
                value={formik.values.password}
              />
            </Stack>

            {
              loginError && (
                
              <Stack spacing={3} sx={{
                alignItems: 'center',
                mt: 2
              }}>
                <Alert sx={{
                  width: '100%'
                }} severity="error">{loginError}</Alert>
              </Stack>
            )
            }

            <LoadingButton
                loading={loading}
                fullWidth
                sx={{ mt: 3 }}
                size="large"
                type="submit"
                variant="contained"
              >
                Continuar
              </LoadingButton>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 3
              }}
            >
              <Link
                href="#"
                underline="hover"
                variant="subtitle2"
              >
                Esqueceu a senha?
              </Link>
            </Box>
          </form>
        </CardContent>
      </Card>
        </Container>
      </Box>
    </LayoutRoot>
  )
}
